import { Link } from "react-router-dom";

const StudentNotFound = () => {
	return (
		<div>
			{/* Content Header (Page header) */}
			<section className="content-header">
				<div className="container-fluid">
					<div className="row mb-2">
						<div className="col-sm-6">
							{/* <h1>Student Not Assigned</h1> */}
						</div>
						<div className="col-sm-6">
							<ol className="breadcrumb float-sm-right">
								<li className="breadcrumb-item"><a href="/">Home</a></li>
								<li className="breadcrumb-item active">Student Not Assigned</li>
							</ol>
						</div>
					</div>
				</div>{/* /.container-fluid */}
			</section>
			{/* Main content */}
			<section className="content stud-not-found">
				<div className="card p-4 text-center" style={{maxWidth: '450px', margin: '60px auto', border: 'none', borderRadius: '10px', boxShadow: '0 0 15px rgba(0, 0, 0, 0.05)'}}>
					<div className="avatar-container mx-auto">
						<img src="/img/404-612x612.jpg" className="avatar" alt="Student Image" />
						<div className="badge-error-red">!</div>
					</div>
					<h4 className="mt-3 font-weight-bold">Student Not Assigned</h4>
					<p className="text-muted mb-3">The student has not been assigned to a parent account yet.</p>
					<div className="mb-4" style={{backgroundColor: "#f1f5f9", borderRadius: '8px', padding: '1rem', fontSize: '0.9rem'}}>
						<p><strong className="mb-2 d-block">What this means:</strong></p>
						<ul className="mb-0 pl-3 text-left">
							<li>The student profile exists but needs a parent connection.</li>
							<li>The parent account must be linked with the student.</li>
						</ul>
						<p className="mt-3 font-weight-bold">Contact the FCL Centre Manager for assistance.</p>
					</div>
					<div className="">{/* d-flex justify-content-between */}
						{/* <button className="btn btn-outline-dark w-50 mr-2">Go Back</button> */}
						<Link className="btn btn-outline-dark w-50" to='/'>Go To Dashboard</Link>
						{/* <button className="btn btn-dark w-50 ml-2">Contact Support</button> */}
					</div>
				</div>
			</section>
			{/* /.content */}
		</div>
	);
};

export default StudentNotFound;